const formatStringWithPrefixAndSuffix = (
  input: string | number | undefined,
  prefix: string | null = null,
  suffix: string | null = null
) => {
  if (input !== undefined && prefix === null && suffix !== null) {
    return input + ' ' + suffix;
  }

  if (input !== undefined && prefix !== null && suffix === null) {
    return prefix + ' ' + input;
  }

  if (input !== undefined && prefix !== null && suffix !== null) {
    return prefix + ' ' + input + ' ' + suffix;
  }

  return '';
};

export { formatStringWithPrefixAndSuffix };
